const BaseElement = require("./base/base-element.js");

class QRCodeElement extends BaseElement {
    constructor() {
        super();
    }
}

module.exports = QRCodeElement;